module.exports = __webpack_public_path__ + "static/media/pt_pay_later.bcc9c758.svg";